import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import { GET_LIST } from 'react-admin';
import compose from 'recompose/compose';

import SourceTypeStats from './SourceTypeStats';
import MediaSourcesStats from './MediaSourcesStats';
import TwitterStats from './TwitterStats';
import ArticlesStats from './ArticlesStats';
import TopicsStats from './TopicsStats';

import restClient from '../services/restClient';
import { appOptions } from '../config/app';

const styles = {
  flex: { display: 'flex' },
  content: { width: '100%' },
  leftCol: { flex: 1, marginRight: '1em' },
  rightCol: { flex: 1, marginLeft: '1em' },
  singleCol: { marginTop: '2em' },
};

class Dashboard extends Component {
  state = {};

  componentDidMount() {
    const lastMonth = new Date();
    lastMonth.setDate(lastMonth.getDate() - 30);
    const apiClient = restClient(appOptions);

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    apiClient(GET_LIST, 'mediasources/types').then(res => {
      const typesMap = new Map();
      res.data.forEach(el => {
        typesMap.set(el.id, el.name);
      });

      this.setState({ types: typesMap });
    });

    apiClient(GET_LIST, 'mediasources/stats').then(res => {
      this.setState({ mediasources: res });
    });

    apiClient(GET_LIST, 'articles/categories').then(res => {
      const typesMap = new Map();
      res.data.forEach(el => {
        typesMap.set(el.id, el.name);
      });

      this.setState({ categories: typesMap });
    });

    apiClient(GET_LIST, 'articles/stats/hourly', { from: yesterday.toISOString() }).then(res => {
      this.setState({ hourly: res });
    });

    apiClient(GET_LIST, 'articles/stats/fb', { size: 10, from: lastMonth.toISOString() }).then(res => {
      this.setState({ facebook: res });
    });

    apiClient(GET_LIST, 'tweets/stats/top-users', { size: 10, from: lastMonth.toISOString() }).then(res => {
      this.setState({ twitter: res });
    });

    apiClient(GET_LIST, 'topics/stats').then(res => {
      this.setState({ topics: res });
    });
  }

  render() {
    const { classes } = this.props;
    const { types, mediasources, hourly, twitter, facebook, topics } = this.state;
    return (
      <div className={classes.content}>
        <div className={classes.flex}>
          <TopicsStats items={topics} />
          <ArticlesStats hourly={hourly} />
        </div>
        <div className={classes.flex}>
          <SourceTypeStats types={types} sources={mediasources} />
          <MediaSourcesStats items={facebook} />
          <TwitterStats items={twitter} />
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};


const enhance = compose(
  withStyles(styles),
  withWidth()
);

export default enhance(Dashboard);



// WEBPACK FOOTER //
// ./src/dashboard/Dashboard.js